import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "history" }
const _hoisted_2 = { class: "list" }

import ChatListItem from "@/views/Home/components/ChatListItem.vue";
import { ref, computed, reactive, watch, onMounted, onBeforeMount } from "vue";
import {
  bindDialogue,
  chatStatus,
  initChat,
} from "@/views/Home/useData/module/chat";
import {
  dialogueStatus,
  dialogueList,
  setSessionId,
  nextDialoguePage,
} from "@/views/Home/useData/module/dialogue";
import { ElMessage } from "element-plus";
import { resetInputBar } from "@/components/Dialogues/useData/useInputBar";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatListHistory',
  setup(__props) {

bindDialogue("dialogueStatus", dialogueStatus);
bindDialogue("dialogueList", dialogueList);

const loadHistory = () => {
  console.log("load history");
  nextDialoguePage();
};

const sessionId = computed(() => {
  return dialogueStatus.sessionId;
});

const isReplying = computed(() => {
  return chatStatus.isReplying;
});

watch(
  sessionId,
  (nVal) => {
    const curDialogue = dialogueList.find((dialogue) => {
      const sid = (dialogue as any).session_id;
      return sid === nVal;
    });
    console.log("watch sessionId ", sessionId);
    console.log("curDialogue", curDialogue);
    initChat(sessionId.value, curDialogue);

    //重制对话框
    resetInputBar();
  },
  {
    immediate: true,
  }
);

const changeSession = (index: number) => {
  if (isReplying.value) {
    ElMessage.warning("当前对话正在进行中，请先结束当前对话");
    return;
  }

  const item = dialogueList[index] as any;

  if (item.session_id === sessionId.value) {
    return;
  }

  setSessionId(item.session_id);
};

const isSelectedDialogue = (index: number) => {
  const item = dialogueList[index] as any;
  return item.session_id === sessionId.value;
};

return (_ctx: any,_cache: any) => {
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dialogueList), (item, index) => {
          return (_openBlock(), _createBlock(ChatListItem, {
            key: item.session_id,
            sessionItem: item,
            index: index,
            isSelected: isSelectedDialogue(index),
            onChangeDialogue: ($event: any) => (changeSession(index))
          }, null, 8, ["sessionItem", "index", "isSelected", "onChangeDialogue"]))
        }), 128))
      ])
    ])), [
      [_directive_infinite_scroll, loadHistory]
    ])
  ]))
}
}

})